import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HighlightedItemSource, HighlightedItemUpdate } from '../../../../shared/models/highlighted-item-update';

@Injectable({
  providedIn: 'root',
})
export class StormMapDataService {
  private stormAnimationEndReachedSource = new Subject();
  readonly stormAnimationEndReached$ = this.stormAnimationEndReachedSource.asObservable();

  private highlightedObservationSource = new BehaviorSubject<HighlightedItemUpdate>(new HighlightedItemUpdate(null, null));
  readonly highlightedObservation$ = this.highlightedObservationSource.asObservable();

  private timeFilterSource = new Subject<number>();
  readonly timeFilter$ = this.timeFilterSource.asObservable();

  private highlightedShiftSource = new BehaviorSubject<HighlightedItemUpdate>(new HighlightedItemUpdate(null, null));
  readonly highlightedShift$ = this.highlightedShiftSource.asObservable();

  sendStormEndReached() {
    this.stormAnimationEndReachedSource.next(true);
  }

  sendHighlightedObservationUpdate(observationId: number, source: HighlightedItemSource) {
    this.highlightedObservationSource.next(new HighlightedItemUpdate(observationId, source));
  }

  filterByTime(timeTo: number) {
    this.timeFilterSource.next(timeTo);
  }

  sendHighlightedShiftUpdate(shiftId: number, source: HighlightedItemSource) {
    this.highlightedShiftSource.next(new HighlightedItemUpdate(shiftId, source));
  }
}
